import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

const Metatags = ({ title }) => {
  return (
    <HelmetProvider>
      <Helmet>
        <title>Red Lemon Events - {title}</title>
      </Helmet>
    </HelmetProvider>
  );
};

export default Metatags;
